export const normalizeMovementPageResponse = (response) => {
  const items = Array.isArray(response)
    ? response
    : (response?.items || response?.data || [])
  const total = response?.pagination?.total

  return {
    items,
    total: Number.isFinite(Number(total)) ? Number(total) : items.length,
  }
}
